<template>
  <div class="mb-6">
      <div class="font-bold text-lg flex items-center gap-2">
          <p>Travel Claim</p>
          <span>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15.7131 12L9.70209 5.99001L8.28809 7.40401L12.8881 12.004L8.28809 16.597L9.70209 18.011L15.7131 12Z" fill="#000000"></path>
            </svg>
        </span>
      </div>
  </div>
</template>

<script>
export default {
    props: ['currentStep']
}
</script>

<style>

</style>